import { connect } from "react-redux";
import { Form, Icon, Input, Button, Checkbox } from "antd";
import { Row,Col } from "antd";
import React, { Component } from "react";
import AuthenActions from "../reducers/AuthenReducer";
import { OocaLogo } from "../theme/Icons";
import { forgotPassword} from "../actions/UserAction";
import PersistGateLoading ,{ ContainerLoading }from "../components/loading/PersistGateLoading";
import { clone } from "ramda";
import I18n from "../i18n/index";



const FormItem = Form.Item;

class Login extends Component {
    state = {
    	login : true,
    	loading : false
    }

    convertUsernameToEmailOrTel = (user) => {
    	const result = clone(user);
    	if (result.username.includes("@")) {
    		result.email = result.username;
    		result.tel = "";
    	} else {
    		result.tel = this.normalizedTel(result.username);
    		result.email = "";
    	}
    	delete result.username;
    	return result;
    }

    forgetPassword = (user) => {
    	const result = {};
    	if (user.username.includes("@")) {
    		result.email = user.username;
    		result.tel = "";
    	} else {
    		result.tel = this.normalizedTel(user.username);
    		result.email = "";
    	}
    	console.log(result);
    	return result;
    }

    normalizedTel = (tel) => {
    	let retval = tel;

    	if (retval.substring(0, 1) === "0") {
    		retval = `+66${retval.substring(1)}`;
    	}

    	return retval;
    }

    checkEmailOrTel = (rule, value, callback) => {

    	if (value === null || value === undefined || value === "") {
    		callback();
    	}
    	const passEmail = (new RegExp("^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$")).test(value);
    	const passTel = (new RegExp("^(0\\d{9}|\\+66\\d{9})$")).test(value);
    	if(passEmail || passTel)
    		callback();
    	else
    		callback(I18n.t("loginPage.checkUsername"));

    }

    handleSubmit = (e) => {
    	e.preventDefault();
    	this.props.form.validateFields((err, values) => {
    		if (!err) {
    			if(this.state.login) {
    				const { email ,tel, password } = this.convertUsernameToEmailOrTel(values);
    				const { loginRequest } = this.props;
    				loginRequest(email, tel, password);
    			} else {
    				this.setState({loading:true});
    				const { email, tel } = this.forgetPassword(values);
    				forgotPassword({email : email , tel : tel})
    					.then(res=>{
    						this.setState({
    							login : true,
    							loading : false
    						});
    					});
    			}
    		}
    	});
    }
    changeForm = (e) => {
    	e.preventDefault();
    	this.setState({
    		login : !this.state.login
    	});

    }
    render() {
    	const { getFieldDecorator } = this.props.form;
    	return <Row align="middle" justify="center" type="flex" style={{ height: "100vh" }}>
    		<Col span={10}>
    			<Form onSubmit={this.handleSubmit} className="login-form">
    				<Form.Item>
    					<OocaLogo />
    				</Form.Item>
    				<FormItem>
    					<div style={{ textAlign: "center" }}>
    						<h2>{I18n.t("loginPage.welcome")}</h2>
    						<h4>
    							{this.state.login
    								? I18n.t("loginPage.titleLogin")
    								: I18n.t("loginPage.titleForgotPassword")}
    						</h4>
    					</div>
    				</FormItem>
    				<ContainerLoading isLoading={this.state.loading}>
    					<FormItem label={I18n.t("username")} labelCol={{ span: 6 }} wrapperCol={{ span: 15 }}>
    						{getFieldDecorator("username", {
    							rules: [
    								{
    									required: true,
    									message: I18n.t("loginPage.requireUsername")
    								},
    								{
    									validator: this.checkEmailOrTel
    								}
    							]
    						})(<Input prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />} placeholder="Email or mobile number" />)}
    					</FormItem>

    					{this.state.login ? <FormItem label={I18n.t("password")} labelCol={{ span: 6 }} wrapperCol={{ span: 15 }}>
    						{getFieldDecorator("password", {
    							rules: [
    								{
    									required: true,
    									message: I18n.t("loginPage.requirePassword")
    								}
    							]
    						})(<Input prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />} type="password" placeholder="Password" />)}
    					</FormItem> : undefined}

    					<FormItem wrapperCol={{ span: 15, offset: 6 }}>
    						<a className="login-form-forgot" onClick={this.changeForm}>
    							{this.state.login ? I18n.t("loginPage.linkForgotPassword") : I18n.t("loginPage.linkBackToLogin")}
    						</a>
    					</FormItem>
    					<FormItem>
    						<Button type="primary" htmlType="submit" className="login-form-button" style={{ display: "block", margin: "auto" }}>
    							{this.state.login ? I18n.t("loginPage.btnLogin") : I18n.t("loginPage.btnForgotPassword")}
    						</Button>
    					</FormItem>
    				</ContainerLoading>
    			</Form>
    		</Col>
    	</Row>;
    }
}

const mapStateToDispatch = dispatch => ({
	loginRequest: (email, tel, password) => dispatch(AuthenActions.loginRequest(email, tel, password))
});

const WrappedNormalLoginForm = Form.create()(Login);
export default connect(null, mapStateToDispatch)(WrappedNormalLoginForm);



// WEBPACK FOOTER //
// ./src/containers/Login.js